/**
 * @file 积分充值弹窗类型定义
 */

/**
 * 积分充值弹窗打开来源（scene_key）
 */
export const PointsRechargeModalSource = {
    /** 会员订阅页_单独购买积分btn */
    MEMBERSHIP_SUBSCRIPTION_PAGE_PURCHASE_POINTS_SEPARATELY_BTN:
        'membership_subscription_page_purchase_points_separately_btn',
    /** 首页个人头像面板_购买积分btn */
    HOME_PERSONAL_AVATAR_PANEL_PURCHASE_POINTS_BTN:
        'home_personal_avatar_panel_purchase_points_btn',
    /** 积分不足提醒弹窗_充值积分btn */
    INSUFFICIENT_POINTS_REMINDER_POPUP_RECHARGE_POINTS_BTN:
        'insufficient_points_reminder_popup_recharge_points_btn',
    /** 积分不足_权限不足提醒卡片_充值积分btn */
    INSUFFICIENT_POINTS_INSUFFICIENT_PERMISSIONS_REMINDER_CARD_RECHARGE_POINTS_BTN:
        'insufficient_points_insufficient_permissions_reminder_card_recharge_points_btn',
    /** 积分消耗详情页弹窗_充值积分btn */
    POINTS_CONSUMPTION_DETAILS_PAGE_POPUP_RECHARGE_POINTS_BTN:
        'points_consumption_details_page_popup_recharge_points_btn',
    /** 首页侧边栏_充值积分btn */
    HOME_SIDEBAR_RECHARGE_POINTS_BTN: 'home_sidebar_recharge_points_btn',
} as const;

export type PointsRechargeModalSourceType =
    (typeof PointsRechargeModalSource)[keyof typeof PointsRechargeModalSource];

/** package_id 枚举：按 SKU 在列表中的顺序依次对应 */
export const PACKAGE_ID_ENUMS = [
    'pkg_50',
    'pkg_100',
    'pkg_500',
    'pkg_1000',
    'pkg_3000',
    'pkg_6000',
];
